import { render, staticRenderFns } from "./Avantage.vue?vue&type=template&id=0f4fe896&scoped=true"
import script from "./Avantage.vue?vue&type=script&lang=js"
export * from "./Avantage.vue?vue&type=script&lang=js"
import style0 from "./Avantage.vue?vue&type=style&index=0&id=0f4fe896&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4fe896",
  null
  
)

export default component.exports